import { formatOlbStyleAuthAmountValueFromBackend } from "./auth-amount-utility";
import { removeNonNumericCharacters } from "../../../utils/utils";
import moment from "moment";

export const constructRecurringRequest = (values) => {
  let paymentDetails = Object.assign({}, values);

  const recurringSetup = {
    PaymentDate: paymentDetails.PaymentDate,
    PaymentFrequency: paymentDetails.PaymentFrequency,
    AuthorizationType: "",
    OpenEndPaymentType: paymentDetails.OpenEndPaymentType || "",
    EndOfMonth: paymentDetails.EndOfMonth,
  };

  // If there is no amount we can infer that this is an open ended recurring payment
  // Which utilizes the OpenEndPaymentType instead
  paymentDetails.Amount = paymentDetails.Amount
    ? removeNonNumericCharacters(paymentDetails.Amount)
    : "0";
  paymentDetails.RecurringPaymentAgreementSetup = recurringSetup;

  // Clean up request
  delete paymentDetails.PaymentDate;
  delete paymentDetails.PaymentFrequency;
  delete paymentDetails.EndOfMonth;

  return paymentDetails;
};

export const constructRecurringInitializationObject = (recurringPayment) => {
  const initializationObject = {
    PaymentFrequency: recurringPayment.RecurringPaymentFrequency,
    PaymentDate: moment(recurringPayment.NextScheduledDtTm).toDate(),
    OpenEndPaymentType: recurringPayment.OpenEndedPaymentType,
    Amount: recurringPayment.Amount
      ? formatOlbStyleAuthAmountValueFromBackend(recurringPayment.Amount)
      : "",
    isChecking: recurringPayment.IsChecking === true ? "true" : "false",
    NameOnAccount: recurringPayment.NameOnAccount,
    RoutingNumber: recurringPayment.RoutingNumber,
    AccountNumber: recurringPayment.AccountNumber,
    AccountNumberVerification: recurringPayment.AccountNumber,
    AccountHash: recurringPayment.PaymentAccountHash,
    EndOfMonth: recurringPayment.EndOfMonth,
  };

  return initializationObject;
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/recurring-utils.js